import React, { useContext, useState } from 'react';
import { Dialog, makeStyles } from '@material-ui/core';

import { Button } from '../'
import ScreenTextContext from '../../contexts/ScreenTextContext';

const useStyles = makeStyles((theme) => ({
  dialog: {
     '.MuiDialog-root .MuiPaper-rounded ': {
       width: 'auto',
       borderRadius: '2rem'
     },
  },
  paper: {
    margin: '0rem 26.5rem',
    borderRadius: '0 !important',
    [theme.breakpoints.up('lg')]: {
      margin: '0rem 31rem', // same as .play__container + 25rem
    },
    [theme.breakpoints.up('xl')]: {
      margin: '0rem 35rem', 
    },
    background: 'transparent',
    '& .scenario': {
      padding: 0
    }
  }
}))


const DialogWrapper = ({conditionalWrap, children, scenario, btnText}) => {
  const [open, setOpen] = useState(false);

  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  }

  const handleOpenClick = () => {
    setOpen(true)
  }

  if (conditionalWrap) {

    return (
      <div className="scenario__dialog-wrapper">
        <Button type="button" variant="text" onClick={handleOpenClick} className="scenario__dialog-btn"><span className="scenario__dialog-btn-text">{scenario.CHALLENGETITLE[0]}</span>&nbsp;&nbsp;<i className="fas fa-external-link-alt"></i></Button>
        <Dialog
          BackdropProps={{className: "modal__backdrop" }}
          open={open}
          onClose={handleClose}
          maxWidth={null}
          PaperProps={{
            className: classes.paper,
            elevation:0,
          }}
        >
          <>
            {children}
            <Button type="button" variant="primary" onClick={handleClose}>{btnText}</Button>
          </>
        </Dialog>
      </div>
    )

  } else {
    return children
  }

}

export const Scenario = ({scenario, popover}) => {

  const { screenText } = useContext(ScreenTextContext)

  const getConsequences = (tasks) => {
    const consequences = [];
    const consequencesText = [];

    tasks.forEach((task, i) => {
      
      const consequence = task.CONSEQUENCE[0].$.category;

      if (consequencesText.indexOf(consequence) < 0){
        consequencesText.push(consequence)
        consequences.push(
          <figure className="scenario__consequence" key={i}>
            <img src={`${process.env.PUBLIC_URL}/assets/images/responses/${consequence}.png`} alt="" />
            <figcaption>{screenText.global.consequenceCategories[consequence]}</figcaption>
          </figure>
        )
      }

    })

    return consequences;
  }
  
  return (
    <DialogWrapper conditionalWrap={popover} scenario={scenario} btnText={screenText.play.scenario.btn}>
      <div className="scenario">

        {popover ? "" : 
          <div className="scenario__image" role="img" aria-label={scenario.IMAGE[0].$.alt} style={{backgroundImage: `url(/resources/tasks/images/${scenario.IMAGE[0].$.src})` }}></div>
        }

        <div className="scenario__container">

          <div className="scenario__pretitle">
            {scenario.CHALLENGETITLE[0]}
          </div>
          <div className="scenario__title">
            {scenario.TITLE[0]}
          </div>

          <div className="scenario__mini-title">
            {screenText.play.scenario.sceneTitle}
          </div>
          <div className="scenario__situation">
            {scenario.TEXT[0]}
          </div>
          <div className="scenario__mini-title">
            {screenText.play.scenario.falloutTitle}
          </div>
          <div className="scenario__consequences">
            {getConsequences(scenario.TASK)}
          </div>
        </div>

      </div>
    </DialogWrapper>
  )

}